import { css } from '@emotion/css';

const screenSizeS = '576px';

const styles = {
  aragModifyContainer: css`
    display: flex;
    justify-content: center;
    height: 100%;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    width: 100%;
  `,
  aragDetailsContainer: css`
    border: 1px solid rgb(214, 214, 214);
    border-radius: 4px;
    padding: 24px 16px 0 16px;

    @media screen and (min-width: ${screenSizeS}) {
      width: 530px;
    }
  `,
  aragCompanyName: { fontWeight: 'bold' },
  iconLink: css`
    display: flex;
    align-items: center;
  `,
  aragContainer: css`
    display: flex;
  `,
  content: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    flex: 1 1;
  `,
  column: css`
    position: relative;
    width: 100%;
    max-width: 530px;
  `,
  radiosLabel: css`
    display: block;
    line-height: 20px;
    font-size: 1.4rem;
    font-weight: 600;
    padding-bottom: 4px;
  `,
  radios: css`
    display: flex;
    align-items: center;
  `,
  row: css`
    margin-bottom: 11px;
  `,
  loaderContainer: css`
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  address1: css`
    width: 100%;
    display: flex;
    align-items: center;
  `,
  street: css`
    flex: 4;
    margin-right: 15px;
  `,
  houseNumber: css`
    flex: 1;
    min-width: 70px;
  `,
  address2: css`
    width: 100%;
    display: flex;
    align-items: center;
  `,
  postcode: css`
    flex: 1;
    min-width: 120px;
    @media screen and (min-width: ${screenSizeS}) {
      min-width: 70px;
    }
    margin-right: 15px;
  `,
  city: css`
    flex: 4;
  `,
  modifyFooter: css`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    max-width: 530px;
    margin-bottom: 24px;
  `,
  lightgray: css`
    color: var(--color-text-default);
  `,
};

export default styles;
